"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Vertical = void 0;
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const react_1 = __importStar(require("react"));
const Gutter_1 = __importDefault(require("../Gutter"));
const makeMyClasses = (props) => ({
    root: {
        position: !!props.hideIf ? 'relative' : undefined,
        transition: 'width 0.3s, opacity 0.15s',
        flex: props.shrink ? 0 : 1,
        height: props.shrink ? 'auto' : '100%',
        display: 'flex',
        flexDirection: 'column',
        opacity: !!props.hideIf ? (props.hideIf[0] ? 0 : 1) : undefined,
        pointerEvents: !!props.hideIf ? (props.hideIf[0] ? 'none' : undefined) : undefined,
        width: !!props.hideIf ? (props.hideIf[0] ? 0 : props.hideIf[1]) : undefined,
        cursor: props.onClick ? 'pointer' : undefined,
        alignItems: props.centered ? 'center' : undefined,
        justifyContent: props.justify ? props.justify : 'flex-start',
        padding: props.padding
            ? '8px 16px'
            : props.paddingX
                ? '0 16px'
                : props.paddingY
                    ? '8px 0'
                    : '',
        overflow: props.scroll ? 'scroll' : props.hidden ? 'hidden' : undefined,
        overflowY: props.scrollY ? 'scroll' : undefined,
        '&:focus': {
            outline: 'none',
            border: 0,
        },
    },
});
exports.Vertical = react_1.default.forwardRef((props, ref) => {
    const { children, gutter, divider, classes, style, onClick, onPointerDown, onScroll, onKeyDown, onMouseEnter, onMouseLeave, } = props;
    const myCss = (0, web_css_1.default)(makeMyClasses, [props], classes);
    let contents;
    if (children instanceof Array && gutter)
        contents = children
            .filter(child => !!child)
            .map((child, i) => (i > 0 ? [react_1.default.createElement(Gutter_1.default, { key: i }), child] : child))
            .flat();
    else if (children instanceof Array && divider)
        contents = children
            .filter(child => !!child)
            .map((child, i) => i > 0
            ? [
                react_1.default.createElement(Gutter_1.default, { key: 'l' + i, style: { borderBottom: `1px solid ${lib_palette_1.default.BorderGrey.main}` } }),
                react_1.default.createElement(Gutter_1.default, { key: 'r' + i }),
                child,
            ]
            : child)
            .flat();
    else
        contents = children;
    return (0, react_1.useMemo)(() => (react_1.default.createElement("div", { ref: ref, tabIndex: onClick ? 0 : undefined, onClick: onClick, onPointerDown: onPointerDown, onScroll: onScroll, onKeyDown: onKeyDown, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, style: style, className: myCss.root }, contents)), [
        contents,
        myCss,
        onClick,
        onKeyDown,
        onMouseEnter,
        onMouseLeave,
        onPointerDown,
        onScroll,
        ref,
        style,
    ]);
});
exports.default = exports.Vertical;
